let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("drXFW")).then(() => parcelRequire('8E4Ir'));